import { shareAttachmentActionCreators } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FormsListPage from '../components/FormListPage'
import {
  actionCreators,
  IFormsListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectScope,
  selectTotalItems,
} from '../modules/formsList'

export default connect(
  createStructuredSelector<ApplicationState, IFormsListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    scope: selectScope(),
    totalItems: selectTotalItems(),
  }),
  { ...actionCreators, ...shareAttachmentActionCreators },
)(FormsListPage)
